import { render, staticRenderFns } from "./ConstelDetails.vue?vue&type=template&id=4f6fe6dd&scoped=true"
import script from "./ConstelDetails.vue?vue&type=script&lang=js"
export * from "./ConstelDetails.vue?vue&type=script&lang=js"
import style0 from "./ConstelDetails.vue?vue&type=style&index=0&id=4f6fe6dd&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f6fe6dd",
  null
  
)

export default component.exports